import { render, staticRenderFns } from "./topicGoal.vue?vue&type=template&id=6e772124&scoped=true"
import script from "./topicGoal.vue?vue&type=script&lang=ts"
export * from "./topicGoal.vue?vue&type=script&lang=ts"
import style0 from "./topicGoal.vue?vue&type=style&index=0&id=6e772124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e772124",
  null
  
)

export default component.exports